import React from 'react';
import { Play } from 'lucide-react';
import GameArtwork from '../../components/GameArtwork';
import { HOOKS, hook } from '../../lib/domHooks';

// Referans arayüzün oyun kartı **dikey (3/4)** ve yazılar kartın içindedir:
// alt kenardaki karartma bandının üstünde oyun adı büyük harflerle, altında
// sağlayıcı adı küçük punto ile durur. Ad kartın altına yazılırsa şerit
// yüksekliği oyun adının uzunluğuna göre oynar ve ızgara hizasını kaybeder —
// referansın kartları bu yüzden sabit oranlıdır.
//
// Rozet sol üsttedir ve tek satırdır: aynı anda hem "YENİ" hem "SICAK"
// göstermek kartın köşesini kalabalıklaştırır, öncelik yeniliğindir.
//
// "CANLI" hepsinin önündedir: canlı casino masasında oyuncunun görmesi
// gereken tek şey masanın açık olduğudur, masanın ayrıca yeni olması onun
// yanında bilgi değildir.

const badgeOf = (game) => {
  if (game.live) return { label: 'CANLI', tone: 'is-live', dot: true };
  if (game.new) return { label: 'YENİ', tone: 'is-new' };
  if (game.hot) return { label: 'SICAK', tone: 'is-hot' };
  if (game.featured) return { label: 'ÖZEL', tone: 'is-special' };
  return null;
};

const HerkulGameCard = ({ game, onPlay }) => {
  const play = () => onPlay?.(game);
  const badge = badgeOf(game);

  return (
    <div
      {...hook(HOOKS.GAME_CARD)}
      className="herkul-card"
      onClick={play}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => { if (event.key === 'Enter') play(); }}
    >
      <div className="herkul-card-art">
        <GameArtwork src={game.img || game.image} alt={game.name} />

        {badge && (
          <span className={`herkul-card-badge ${badge.tone}`}>
            {badge.dot && <i className="herkul-card-badge-dot" />}
            {badge.label}
          </span>
        )}

        {/* Adın okunabilirliği görselden bağımsız olmalı: açık zeminli
            kapaklarda beyaz yazı kaybolduğu için band her zaman çizilir. */}
        <div className="herkul-card-meta">
          <span className="herkul-card-name">{game.name}</span>
          {game.provider && <span className="herkul-card-provider">{game.provider}</span>}
        </div>

        <span className="herkul-card-play" aria-hidden="true">
          <span className="herkul-card-play-btn"><Play size={18} /></span>
        </span>
      </div>
    </div>
  );
};

export default HerkulGameCard;
